<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstApplication"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedApplication"
		dataKey="ApplicationID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--ApplicationName-->
				<th>
					<p-columnFilter type="text" field="ApplicationName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ApplicationDesc-->
				<th>
					<p-columnFilter type="text" field="ApplicationDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--InterfaceTypeDesc-->
				<th>
					<p-columnFilter field="InterfaceTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterInterfaceTypeDesc
								[ngModel]="value"
								[options]="lstInterfaceTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--IsApplicationInstalledDesc-->
				<th class="fixwidth-09">
					<p-columnFilter field="IsApplicationInstalledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsApplicationInstalledDesc
								[ngModel]="value"
								[options]="lstIsApplicationInstalledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--IsBaseInstallDesc-->
				<th class="fixwidth-09">
					<p-columnFilter field="IsBaseInstallDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsBaseInstallDesc
								[ngModel]="value"
								[options]="lstIsBaseInstallDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--InstalledInASchoolDesc-->
				<th class="fixwidth-09">
					<p-columnFilter field="InstalledInASchoolDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterInstalledInASchoolDesc
								[ngModel]="value"
								[options]="lstInstalledInASchoolDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-09"></th>

				<th class="fixwidth-09">
					<p-columnFilter field="MenuItemDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterMenuItemDesc
								[ngModel]="value"
								[options]="lstMenuItemDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="ApplicationName">Name<p-sortIcon field="ApplicationName"></p-sortIcon></th>
				<th pSortableColumn="ApplicationDesc">Description<p-sortIcon field="ApplicationDesc"></p-sortIcon></th>
				<th pSortableColumn="InterfaceTypeDesc">Interface<p-sortIcon field="InterfaceTypeDesc"></p-sortIcon></th>

				<th class="fixwidth-09" pSortableColumn="IsApplicationInstalledDesc">Installed<p-sortIcon field="IsApplicationInstalledDesc"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="IsBaseInstallDesc">Base Install<p-sortIcon field="IsBaseInstallDesc"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="InstalledInASchoolDesc">
					Installed in a School<p-sortIcon field="InstalledInASchoolDesc"></p-sortIcon>
				</th>

				<th class="fixwidth-09" pSortableColumn="SchoolCount"># of Schools<p-sortIcon field="SchoolCount"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="MenuItemCount">Menu Items<p-sortIcon field="MenuItemCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Application>
			<tr [pSelectableRow]="Application" (dblclick)="onRowDblClick(Application)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Application[col.field] }}
				</td>

				<td class="fixwidth-09">
					<div class="CheckDiv">
						<i *ngIf="Application.IsApplicationInstalled == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="Application.IsApplicationInstalled == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>

				<td class="fixwidth-09">
					<div class="CheckDiv">
						<i *ngIf="Application.IsBaseInstall == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="Application.IsBaseInstall == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>

				<td class="fixwidth-09">
					<div class="CheckDiv">
						<i *ngIf="Application.InstalledInASchool == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="Application.InstalledInASchool == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>

				<td class="fixwidth-09" style="font-weight: bold">
					{{ Application.SchoolCountDesc }}
				</td>

				<td class="fixwidth-09" style="font-weight: bold">
					{{ Application.MenuItemCount }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
